{
  "ancillaries": {
    "overlappingServicesNotification": {
      "convertMultipleServicesToBundle": "Yhdistä valintasi komboksi ja saat 10 %:n komboalennuksen:",
      "convertServiceToSeatBundle": "Tällä kombolla valitsemasi {overlapCategory} yhdistetään istuinpaikkaasi ja saat 10 %:n komboalennuksen.",
      "convertSeatBundleToSeatBundle": "Voit valita yhden kombon per istuinpaikka. Jos vaihdat komboa, {overlapCategory} -kombo korvataan {currentCategory} -kombolla. Istuinpaikkasi säilyy samana.",
      "convertSeatBundleToSeat": "Kun lisäät istuinpaikan, nykyinen {overlapCategory} -kombo poistuu.",
      "removeServiceFromBundle": "Tämä {currentCategory} poistaa aiemmin valitun {overlapCategory} -kombon.",
      "removeServiceFromSeatBundle": "Jos valitset tämän {currentCategory} vaihtoehdon, komboosi kuuluva {currentCategory} poistuu. Istuinpaikkasi säilyy samana, mutta siihen ei enää sisälly 10 %:n komboalennusta.",
      "replaceMultipleServicesWithBundle": "Kun lisäät tämän kombon, poistuvat nykyiset valintasi, jotka ovat:",
      "replaceServiceWithBundle": "Kun lisäät {currentCategory} -kombon, valitsemasi {overlapCategory} poistuu."
    },
    "seatWifi": { "genericTitle": "Istuinpaikka + Internet" },
    "seatPriority": { "genericTitle": "Istuinpaikka + Priority" },
    "seatCabinBaggage": { "genericTitle": "Istuinpaikka + Käsimatkatavara" },
    "seatMeal": { "genericTitle": "Istuinpaikka + Ateria" },
    "loungeCabinBaggage": { "genericTitle": "Lounge + Käsimatkatavara" },
    "loungePriority": { "genericTitle": "Lounge + Priority" },
    "loungeWifi": { "genericTitle": "Lounge + Internet" },
    "wifiMeal": { "genericTitle": "Internet + Ateria" },
    "seatCombos": {
      "eligibility": {
        "preOrderMealsAvailablePrior36Hours": "Ateriat on ennakkotilattava viimeistään 36 tuntia ennen lennon lähtöä.",
        "preOrderMealsAvailablePrior16Hours": "Ateriat on ennakkotilattava viimeistään 16 tuntia ennen lennon lähtöä",
        "freshMealsAvailablePrior24Hours": "Ateriat on ennakkotilattava viimeistään 24 tuntia ennen lennon lähtöä.",
        "freshMealsAvailablePrior7Hours": "Ateriat on ennakkotilattava viimeistään 7 tuntia ennen lennon lähtöä."
      }
    },
    "ancillaryCombos": {
      "eligibility": {
        "preOrderMealsAvailablePrior36Hours": "Ateriat on ennakkotilattava viimeistään 36 tuntia ennen lennon lähtöä.",
        "preOrderMealsAvailablePrior16Hours": "Ateriat on ennakkotilattava viimeistään 16 tuntia ennen lennon lähtöä",
        "freshMealsAvailablePrior24Hours": "Ateriat on ennakkotilattava viimeistään 24 tuntia ennen lennon lähtöä.",
        "freshMealsAvailablePrior7Hours": "Ateriat on ennakkotilattava viimeistään 7 tuntia ennen lennon lähtöä."
      }
    },
    "quota": {
      "onlyQuotaLeft": {
        "singular": "Vain yksi jäljellä",
        "plural": "{quota} jäljellä"
      },
      "quotaLeft": {
        "singular": "1 jäljellä",
        "plural": "{quota} jäljellä"
      },
      "noQuotaLeft": "0 jäljellä"
    },
    "meals": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Yksi ateria jäljellä",
            "plural": "{amount} ateriaa jäljellä"
          },
          "description": "Valitse ateriasi ennen kuin ne loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään ateriaa jäljellä",
          "description": "Olet lisännyt aterian kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi ateria jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} ateriaa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Aterioita on saatavilla rajattu määrä lentokoneen tilan vuoksi.",
          "noneLeft": "Ei yhtään ateriaa jäljellä."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen aterian toiselle matkustajalle."
      }
    },
    "priority": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi priority-palvelu jäljellä",
            "plural": "Vain {amount} priority-palvelua jäljellä"
          },
          "description": "Kannattaa varmistaa joutuisampi matka nyt."
        },
        "allSelected": {
          "title": "Ei yhtään priority-palvelua jäljellä",
          "description": "Olet lisännyt palvelun kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi priority-palvelu jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} priority-palvelua jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Palvelun saatavuus on rajattu, jotta priority-jonot pysyvät lyhyenä.",
          "noneLeft": "Ei yhtään priority-palvelua jäljellä."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen priority-palvelun toiselle matkustajalle."
      }
    },
    "sport": {
      "quota": {
        "exhausted": {
          "default": "Tila tuotteelle loppu tältä lennolta.",
          "BIKE": "Kaikki tila polkupyörille loppu tältä lennolta.",
          "GOLF": "Kaikki tila golfvarusteille loppu tältä lennolta.",
          "SKIS": "Kaikki tila hiihtovarusteille loppu tältä lennolta.",
          "SURF": "Kaikki tila lainelaudoille loppu tältä lennolta."
        },
        "takenByOtherPassenger": {
          "default": "Valitsit viimeisen tuotteen toiselle matkustajalle.",
          "BIKE": "Valitsit viimeisen polkupyörän toiselle matkustajalle.",
          "GOLF": "Valitsit viimeiset golfvarusteet toiselle matkustajalle.",
          "SKIS": "Valitsit viimeiset hiihtovarusteet toiselle matkustajalle.",
          "SURF": "Valitsit viimeisen lainelaudan toiselle matkustajalle."
        }
      }
    },
    "tags": {
      "bestPriceNow": ""
    },
    "toaster": {
      "errorSavingBundle": "",
      "errorSavingSeatWifi": "Tekemiäsi muutoksia Istuinpaikka + Internet -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingSeatPriority": "Tekemiäsi muutoksia Istuinpaikka + Priority -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingSeatCabinBaggage": "Tekemiäsi muutoksia Istuinpaikka + Käsimatkatavara -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingSeatMeal": "Tekemiäsi muutoksia Istuinpaikka + Ateria -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingLoungeCabinBaggage": "Tekemiäsi muutoksia Lounge + Käsimatkatavara -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingLoungePriority": "Tekemiäsi muutoksia Lounge + Priority -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingLoungeWifi": "Tekemiäsi muutoksia Lounge + Internet -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen.",
      "errorSavingWifiMeal": "Tekemiäsi muutoksia Internet + Ateria -komboon ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen."
    }
  },
  "payment": {
    "paymentCard": {
      "brand": {
        "RP": "RuPay"
      }
    },
    "paymentMethod": {
      "BLIK": "BLIK",
      "PAYTRAIL": "Paytrail",
      "WERO": "Wero",
      "APEXX_PAYMENT_CARD": "Luotto- tai debit-kortti"
    }
  }
}
